import { Box, Typography } from "@mui/material";
import LinkRouter from "../navigation/LinkRouter";
import { DelegationTask } from "protogen/delegations_pb";
import { Zap } from "lucide-react";

export default ({
  delegationTask,
  creatorName,
}: {
  delegationTask: DelegationTask;
  creatorName: string;
}) => {
  const delegationRef = delegationTask.ref;

  return (
    <LinkRouter to={`/tasks/subtasks/${encodeURIComponent(delegationRef)}`}>
      <Box
        sx={{
          backgroundColor: "#FFF",
          border: "1px solid #EAEBEC",
          borderRadius: "12px",
          display: "flex",
          padding: "12px 16px",
          width: "100%",
          gap: "8px",
        }}
      >
        <Zap width={24} height={24} color="#198282" fill="#198282" />
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography
            variant="bodySmall"
            color="text.primary"
            sx={{
              width: "100%",
            }}
          >
            {creatorName} created a lightning task:{" "}
            <Typography
              color="primary.main"
              component="span"
              sx={{ fontWeight: "600", fontSize: "14px" }}
            >
              {delegationTask.title}
            </Typography>
          </Typography>
          {delegationTask.description && (
            <Typography
              variant="bodySmall"
              color="text.secondary"
              sx={{
                marginTop: "4px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {delegationTask.description}
            </Typography>
          )}
        </Box>
      </Box>
    </LinkRouter>
  );
};
